import React from 'react'

const Navbar = () => {
    return (
        <>
            <nav className='flex justify-between px-5 py-1 items-center sticky top-0 bg-blue-700 shadow-md z-20 text-white'>
                 <div><h1 className='text-2xl font-bold cursor-pointer btn'>AR.</h1></div>
                <div><ul className='flex justify-center items-center space-x-2 text-sm'>
                    <li className='btn cursor-pointer'><a href="#projects">Projects</a></li>
                    <li className='btn cursor-pointer'><a href="#skillContainer">Skills</a></li>
                    <li className='btn cursor-pointer'><a href="#contact">Contact</a></li>
                    </ul></div>
            </nav>
        </>
    )
}

export default Navbar